import styles from "./LinkButton.styles.scss";
import {Body} from "../typography";
import Icon from "../Icon/Icon";

const LinkButton = ({text, leftIconName, onClick, color = undefined}) => <button className={styles.linkButtonContainer} style={{color}}
                                                      onClick={onClick}>{leftIconName && <Icon color={color} name={leftIconName} size={16} />}<Body style={{marginLeft: leftIconName ? 4 : 0}}
                                                                                    size='body2'
                                                                                    weight='bold' color={color}>{text}</Body>
</button>;

export default LinkButton;



// WEBPACK FOOTER //
// ./components/LinkButton/LinkButton.js